import React, { useRef, useEffect } from 'react';

import { useStyles } from '../styles';

export interface IActionsMenuItem {
  label: string;
  testId?: string;
  onClick: () => void;
}

interface ActionsMenuProps {
  isOpen: boolean;
  items: IActionsMenuItem[];
  onClose: () => void;
  // Viewport coordinates snapshotted by the card when the menu opens (mirrors MyCertifications).
  position: { top: number; right: number };
  testId?: string;
}

const ActionsMenu: React.FC<ActionsMenuProps> = ({ isOpen, items, onClose, position, testId }) => {
  const classes = useStyles();
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      // The menu is position:fixed at coords snapshotted on open, so it would float free of
      // its card on scroll/resize — dismiss it instead (standard dropdown behavior).
      window.addEventListener('scroll', onClose, true);
      window.addEventListener('resize', onClose);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('scroll', onClose, true);
      window.removeEventListener('resize', onClose);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      ref={menuRef}
      className={classes.actionsMenu}
      style={{ top: position.top, right: position.right }}
      data-testid={testId}
    >
      {items.map(item => (
        <button
          key={item.label}
          className={classes.actionsMenuItem}
          data-testid={item.testId}
          onClick={e => {
            e.stopPropagation();
            item.onClick();
            onClose();
          }}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
};

export default ActionsMenu;
